var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","tile":"","outlined":"","depressed":"","color":"primary","dark":""},on:{"click":_vm.goToNewRequest}},[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v("mdi-plus")]),_vm._v("New Request")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }